import { InputNumber } from "primereact/inputnumber";
import { Divider } from 'primereact/divider';
import { Dropdown } from 'primereact/dropdown';
import { csosn, cst, cstOrigins } from "../utils/options";

const fieldClasses = 'field col-12';
const labelClasses = 'text-gray-800 text-base';
const inputClasses = 'w-50';
const sectionTitleClasses = "text-black-alpha-90 text-xl font-medium mb-4 mt-5"
        
const ICMSForm = ({
  productData,
  setProductData,
  isSimpleNational,
  totalValue,
  sn
}) => {
  const showICMSGroup = 
    productData?.cstTaxation === 0 ||
    productData?.cstTaxation === 10 || 
    productData?.cstTaxation === 20 ||
    productData?.cstTaxation === 51 ||
    productData?.cstTaxation === 70 ||
    productData?.cstTaxation === 90 ||
    productData?.csosn === 900

  const showCalcBasisReduction = 
    productData?.cstTaxation === 20 ||
    productData?.cstTaxation === 51 ||
    productData?.cstTaxation === 70 ||
    productData?.cstTaxation === 80 ||
    productData?.csosn === 900

  const showTributarySubstitution = 
    productData?.cstTaxation === 10 ||
    productData?.cstTaxation === 30 ||
    productData?.cstTaxation === 70 ||
    productData?.cstTaxation === 90 ||
    productData?.csosn === 201 ||
    productData?.csosn === 202 ||
    productData?.csosn === 203 ||
    productData?.csosn === 900

  const showSNTaxRate =
    productData?.csosn === 101 ||
    productData?.csosn === 201 ||
    productData?.csosn === 900

  const showICMSRelief =
    productData?.cstTaxation === 20 ||
    productData?.cstTaxation === 30 ||
    productData?.cstTaxation === 40 ||
    productData?.cstTaxation === 41 ||
    productData?.cstTaxation === 50 ||
    productData?.cstTaxation === 70

  const showDeferral = productData?.cst === 51

  const showPoorPeopleCombatFund =
    productData?.cstTaxation === 0 ||
    productData?.cstTaxation === 10 ||
    productData?.cstTaxation === 51 ||
    productData?.cstTaxation === 70 ||
    productData?.cstTaxation === 90 

  const showPoorPeopleCombatFundCalcBasis = productData?.cstTaxation !== 0

  const showPoorPeopleCombatFundSt =
    productData?.csosn === 201 ||
    productData?.csosn === 900 ||
    productData?.cstTaxation === 10 ||
    productData?.cstTaxation === 30 ||
    productData?.cstTaxation === 70

  const reducedValue = totalValue - (totalValue * (productData?.base?.calcBasisReduction?.code / 100 || 0))
  const ICMSValue = reducedValue * (productData?.base?.taxRate / 100 || 0)

  const reducedValueST = totalValue - (totalValue * (productData?.st?.calcBasisReduction?.code / 100 || 0))
  const ICMSSTValue = reducedValueST * (productData?.st?.taxRate / 100 || 0)

  const SNTaxrate = totalValue * (sn?.taxRate / 100)

  const ICMSExoneration = totalValue * (productData?.base?.taxRate / 100 || 0)

  const exonerationMotives = (() => {
    if(productData?.cstTaxation === 30) {
      return [
        {
          label: 'SUFRAMA',
          code: 7
        },
        {
          label: 'Utilitários e Motocicletas da Amazônia Ocidental e Áreas de Livre Comércio',
          code: 6
        },
        {
          label: 'Outros',
          code: 9
        }
      ]
    }

    if(
      productData?.cstTaxation === 40 ||
      productData?.cstTaxation === 41 ||
      productData?.cstTaxation === 50
     ) {
      return [
        {
          label: 'Não desonerado',
          code: 0
        },
        {
          label: 'Táxi',
          code: 1
        },
        {
          label: 'Produtor Agropecuário',
          code: 3
        },
        {
          label: 'Frotista/Locadora',
          code: 4
        },
        {
          label: 'Diplomático/Consular',
          code: 5
        },
        {
          label: 'Utilitários e Motocicletas da Amazônia Ocidental e Áreas de Livre Comércio',
          code: 6
        },
        {
          label: 'SUFRAMA',
          code: 7
        },
        {
          label: 'Venda a órgão Público',
          code: 8
        },
        {
          label: 'Deficiente Condutor',
          code: 10
        },
        {
          label: 'Deficiente não condutor',
          code: 11
        },
        {
          label: 'Olimpíadas Rio 2016',
          code: 16
        },
        {
          label: 'Solicitado pelo Fisco',
          code: 90
        },
        {
          label: 'Outros',
          code: 9
        }
      ]
    }

    return [
      {
        label: 'Uso na agropecuária',
        code: 3
      }, 
      {
        label: 'Órgão de fomento e desenvolvimento agropecuário',
        code: 12
      }, 
      {
        label: 'Outros',
        code: 9
      }
    ]
  })()

  const deferralValue = ICMSValue * (productData?.deferral?.percent / 100)

  return (
    <>
      <h1 className="text-gray-900 text-2xl font-semibold">ICMS</h1>

      <h2 className={sectionTitleClasses}>Informações gerais</h2>
      <div className="grid">
        <div className={fieldClasses}>
          <label 
            htmlFor="origin" 
            className={labelClasses}
          >
            Origem
          </label>

          <Dropdown
            id="origin"
            value={productData?.originSelect} 
            onChange={(e) => {
              setProductData({
                ...productData,
                originSelect: e.value,
                cstOrigin: e.value?.number
              })
            }}
            options={cstOrigins} 
            optionLabel="description" 
            placeholder="Selecione uma opção" 
            className="w-full" 
            filter
            filterInputAutoFocus
          />
        </div>

        {!isSimpleNational ? (
          <div className={fieldClasses}>
            <label 
              htmlFor="cst" 
              className={labelClasses}
            >
              CST
            </label>

            <Dropdown
              id="cst"
              value={productData?.cstSelect} 
              onChange={(e) => {
                setProductData({
                  ...productData,
                  cstSelect: e.value,
                  cstTaxation: e.value?.number
                })
              }}
              options={cst} 
              optionLabel="description" 
              placeholder="Selecione uma opção" 
              className="w-full" 
              filter
              filterInputAutoFocus
            />
          </div>
        ) : (
          <div className={fieldClasses}>
            <label 
              htmlFor="csosn" 
              className={labelClasses}
            >
              CSOSN
            </label>

            <Dropdown
              id="csosn"
              value={productData?.csosnSelect} 
              onChange={(e) => {
                setProductData({
                  ...productData,
                  csosnSelect: e.value,
                  csosn: e.value?.number,
                })
              }}
              options={csosn} 
              optionLabel="description" 
              placeholder="Selecione uma opção" 
              className="w-full" 
              filter
              filterInputAutoFocus
            />
          </div>
        )}
      </div>

      {showICMSGroup && (
        <>
          <h2 className={sectionTitleClasses}>Detalhes do ICMS</h2>

          <div className="grid">
            <div className={fieldClasses}>
              <label 
                htmlFor="base-calcBasisDetermination" 
                className={`${labelClasses} w-full`}
              >
                Determinação da base de cálculo
              </label>

              <Dropdown
                id="base-calcBasisDetermination"
                value={productData?.base?.calcBasisDeterminationSelect}
                onChange={(e) => {
                  setProductData({
                    ...productData,
                    base: {
                      ...productData?.base,
                      calcBasisDeterminationSelect: e.value,
                      calcBasisDetermination: {
                        code: e.value?.code
                      }
                    }
                  })
                }}
                options={[
                  {
                    label: 'Margem de Valor Agregado.',
                    code: 0,
                  },
                  {
                    label: 'Pauta.',
                    code: 1,
                  },
                  {
                    label: 'Preço tabelado Máx.',
                    code: 2,
                  },
                  {
                    label: 'Valor da operação.',
                    code: 3,
                  },
                ]}
                optionLabel="label"
                placeholder="Margem de Valor Agregado" 
                className="w-full"
              />
            </div>

            {showCalcBasisReduction && (
              <div className={fieldClasses}>
                <label 
                  htmlFor="base-calcBasisReduction" 
                  className={`${labelClasses} w-full`}
                >
                  Redução da base de cálculo
                </label>

                <InputNumber
                  id="base-calcBasisReduction"
                  value={productData?.base?.calcBasisReduction}
                  min={0}
                  useGrouping={false}
                  suffix="%"
                  onChange={(e) => {
                    setProductData({
                      ...productData,
                      base: {
                        ...productData?.base,
                        calcBasisReduction: e.value
                      }
                    })
                  }}
                  className={inputClasses}
                />
              </div>
            )}

            {/* TODO: Adicionar sugestão da tabela ICMS */}
            <div className={fieldClasses}>
              <label 
                htmlFor="base-taxRate" 
                className={`${labelClasses} w-full`}
              >
                Alíquota do imposto
              </label>

              <InputNumber
                id="base-taxRate"
                value={productData?.base?.taxRate}
                min={0}
                useGrouping={false}
                suffix="%"
                onChange={(e) => {
                  setProductData({
                    ...productData,
                    base: {
                      ...productData?.base,
                      taxRate: e.value
                    }
                  })
                }}
                className={inputClasses}
              />
            </div>

            <div className={fieldClasses}>
              <label 
                htmlFor="icms-value" 
                className={`${labelClasses} w-full`}
              >
                Valor do ICMS
              </label>

              <InputNumber
                id="icms-value"
                value={ICMSValue}
                useGrouping={false}
                disabled
                className={inputClasses}
                mode="currency" 
                currency="BRL" 
                locale="pt-BR"
              />
            </div>
          </div>

          <Divider />
        </>
      )}

      {showTributarySubstitution && (
        <>
          <h2 className={sectionTitleClasses}>Substituição tributária</h2>

          <div className="grid">
            <div className={fieldClasses}>
              <label 
                htmlFor="st-calcBasisDetermination" 
                className={`${labelClasses} w-full`}
              >
                Determinação da base de cálculo
              </label>

              <Dropdown
                id="st-calcBasisDetermination"
                value={productData?.st?.calcBasisDeterminationSelect}
                onChange={(e) => {
                  setProductData({
                    ...productData,
                    st: {
                      ...productData?.st,
                      calcBasisDeterminationSelect: e.value,
                      calcBasisDetermination: {
                        code: e.value?.code
                      }
                    }
                  })
                }}
                options={[
                  {
                    label: 'Margem Valor Agregado',
                    code: 4,
                  },
                  {
                    label: 'Pauta',
                    code: 5,
                  }
                ]} 
                placeholder="Selecione uma opção" 
                optionLabel="label"
                className="w-full"
              />
            </div>

            <div className={fieldClasses}>
              <label 
                htmlFor="st-addedValueMargin" 
                className={`${labelClasses} w-full`}
              >
                Margem de valor adicionado
              </label>

              <InputNumber
                id="st-addedValueMargin"
                value={productData?.st?.addedValueMargin}
                min={0}
                useGrouping={false}
                suffix="%"
                onChange={(e) => {
                  setProductData({
                    ...productData,
                    st: {
                      ...productData?.st,
                      addedValueMargin: e.value
                    }
                  })
                }}
                className={inputClasses}
              />
            </div>

            <div className={fieldClasses}>
              <label 
                htmlFor="st-calcBasisReduction" 
                className={`${labelClasses} w-full`}
              >
                Redução da base de cálculo
              </label>

              <InputNumber
                id="st-calcBasisReduction"
                value={productData?.st?.calcBasisReduction}
                min={0}
                useGrouping={false}
                suffix="%"
                onChange={(e) => {
                  setProductData({
                    ...productData,
                    st: {
                      ...productData?.st,
                      calcBasisReduction: e.value
                    }
                  })
                }}
                className={inputClasses}
              />
            </div>

            <div className={fieldClasses}>
              <label 
                htmlFor="st-taxRate" 
                className={`${labelClasses} w-full`}
              >
                Alíquota
              </label>

              <InputNumber
                id="st-taxRate"
                value={productData?.st?.taxRate}
                min={0}
                useGrouping={false}
                suffix="%"
                onChange={(e) => {
                  setProductData({
                    ...productData,
                    st: {
                      ...productData?.st,
                      taxRate: e.value
                    }
                  })
                }}
                className={inputClasses}
              />
            </div>

            <div className={fieldClasses}>
              <label 
                htmlFor="icms-st-value" 
                className={`${labelClasses} w-full`}
              >
                Valor do ICMS ST
              </label>

              <InputNumber
                id="icms-st-value"
                value={ICMSSTValue}
                useGrouping={false}
                disabled
                className={inputClasses}
                mode="currency" 
                currency="BRL" 
                locale="pt-BR"
              />
            </div>
          </div>

          <Divider />
        </>        
      )}

      {showSNTaxRate && (
        <>
          <h2 className={sectionTitleClasses}>Alíquota do Simples Nacional</h2>

          <div className="grid">
            <div className={fieldClasses}>
              <label 
                htmlFor="sn-taxRate" 
                className={`${labelClasses} w-full`}
              >
                Alíquota aplicável
              </label>

              <InputNumber
                id="sn-taxRate"
                value={sn?.taxRate}
                min={0}
                useGrouping={false}
                disabled
                suffix="%"
                className={inputClasses}
              />
            </div>

            <div className={fieldClasses}>
              <label 
                htmlFor="sn-credit" 
                className={`${labelClasses} w-full`}
              >
                Valor de crédito aproveitado
              </label>

              <InputNumber
                id="sn-credit"
                value={SNTaxrate}
                useGrouping={false}
                disabled
                className={inputClasses}
                mode="currency" 
                currency="BRL" 
                locale="pt-BR"
              />
            </div>
          </div>

          <Divider />
        </>        
      )}

      {showICMSRelief && (
        <>
          <h2 className={sectionTitleClasses}>Desoneração do ICMS</h2>

          <div className="grid">
            <div className={fieldClasses}>
              <label 
                htmlFor="relief-reason" 
                className={`${labelClasses} w-full`}
              >
                Motivo da desoneração
              </label>

              <Dropdown
                id="relief-reason"
                value={productData?.relief?.reasonSelect}
                onChange={(e) => {
                  setProductData({
                    ...productData,
                    relief: {
                      ...productData?.relief,
                      reason: e.value?.code,
                      reasonSelect: e.value,
                    }
                  })
                }}
                options={exonerationMotives} 
                optionLabel="label"
                className="w-full"
              />
            </div>

            <div className={fieldClasses}>
              <label 
                htmlFor="relief-amount" 
                className={`${labelClasses} w-full`}
              >
                Valor desonerado
              </label>

              <InputNumber
                id="relief-amount"
                value={ICMSExoneration}
                min={0}
                useGrouping={false}
                disabled
                suffix="%"
                className={inputClasses}
              />
            </div>
          </div>

          <Divider />
        </>        
      )}

      {showDeferral  && (
        <>
          <h2 className={sectionTitleClasses}>Deferimento</h2>

          <div className="grid">
            <div className={fieldClasses}>
              <label 
                htmlFor="deferral-operation-value" 
                className={`${labelClasses} w-full`}
              >
                Valor do ICMS da operação
              </label>

              <InputNumber
                id="deferral-operation-value"
                value={ICMSValue}
                useGrouping={false}
                disabled
                className={inputClasses}
                mode="currency" 
                currency="BRL" 
                locale="pt-BR"
              />
            </div>

            <div className={fieldClasses}>
              <label 
                htmlFor="deferral-percent" 
                className={`${labelClasses} w-full`}
              >
                Percentual do diferimento
              </label>

              <InputNumber
                id="deferral-percent"
                value={productData?.deferral?.percent}
                min={0}
                onChange={(e) => {
                    setProductData({
                      ...productData,
                      deferral: {
                        ...productData?.deferral,
                        percent: e.value
                      }
                    })
                  }
                }
                useGrouping={false}
                suffix="%"
                className={inputClasses}
              />
            </div>

            <div className={fieldClasses}>
              <label 
                htmlFor="deferral-value" 
                className={`${labelClasses} w-full`}
              >
                Valor do ICMS diferido
              </label>

              <InputNumber
                id="deferral-value"
                value={deferralValue}
                useGrouping={false}
                disabled
                className={inputClasses}
                mode="currency" 
                currency="BRL" 
                locale="pt-BR"
              />
            </div>
          </div>
          
          <Divider />
        </>        
      )}

      {showPoorPeopleCombatFund  && (
        <>
          <h2 className={sectionTitleClasses}>Fundo de Combate à Pobreza</h2>

          <div className="grid">
            {showPoorPeopleCombatFundCalcBasis && (
              <div className={fieldClasses}>
                <label 
                  htmlFor="fpc-base" 
                  className={`${labelClasses} w-full`}
                >
                  Base de cálculo do FCP
                </label>

                <InputNumber
                  id="fpc-base"
                  value={reducedValue}
                  useGrouping={false}
                  disabled
                  className={inputClasses}
                  mode="currency" 
                  currency="BRL" 
                  locale="pt-BR"
                />
              </div>
            )}

            <div className={fieldClasses}>
              <label 
                htmlFor="fpc-percent" 
                className={`${labelClasses} w-full`}
              >
                Percentual relativo ao FCP
              </label>

              <InputNumber
                id="fpc-percent"
                value={productData?.fpc?.percent}
                min={0}
                onChange={(e) => {
                    setProductData({
                      ...productData,
                      fpc: {
                        ...productData?.fpc,
                        percent: e.value
                      }
                    })
                  }
                }
                useGrouping={false}
                suffix="%"
                className={inputClasses}
              />
            </div>

            <div className={fieldClasses}>
              <label 
                htmlFor="fpc-value" 
                className={`${labelClasses} w-full`}
              >
                Valor do FCP
              </label>

              <InputNumber
                id="fpc-value"
                value={reducedValue * (productData?.fpc?.percent / 100)}
                useGrouping={false}
                disabled
                className={inputClasses}
                mode="currency" 
                currency="BRL" 
                locale="pt-BR"
              />
            </div>
          </div>
          
          <Divider />
        </>        
      )}

      {showPoorPeopleCombatFundSt  && (
        <>
          <h2 className={sectionTitleClasses}>Fundo de Comate à Pobreza retido por ST</h2>

          <div className="grid">
            <div className={fieldClasses}>
              <label 
                htmlFor="fpcSt-base" 
                className={`${labelClasses} w-full`}
              >
                Base de cálculo do FCP retido
              </label>

              <InputNumber
                id="fpcSt-base"
                value={reducedValueST}
                useGrouping={false}
                disabled
                className={inputClasses}
                mode="currency" 
                currency="BRL" 
                locale="pt-BR"
              />
            </div>

            <div className={fieldClasses}>
              <label 
                htmlFor="fpcSt-percent" 
                className={`${labelClasses} w-full`}
              >
                Percentual retido relativo ao FCP
              </label>

              <InputNumber
                id="fpcSt-percent"
                value={productData?.fpcSt?.percent}
                min={0}
                onChange={(e) => {
                    setProductData({
                      ...productData,
                      fpcSt: {
                        ...productData?.fpcSt,
                        percent: e.value
                      }
                    })
                  }
                }
                useGrouping={false}
                suffix="%"
                className={inputClasses}
              />
            </div>

            <div className={fieldClasses}>
              <label 
                htmlFor="fpcSt-value" 
                className={`${labelClasses} w-full`}
              >
                Valor retido do FCP
              </label>

              <InputNumber
                id="fpcSt-value"
                value={reducedValueST * (productData?.fpcSt?.percent / 100)}
                useGrouping={false}
                disabled
                className={inputClasses}
                mode="currency" 
                currency="BRL" 
                locale="pt-BR"
              />
            </div>
          </div>
        </>        
      )}
    </>
  );
}

export default ICMSForm;